module.exports = __webpack_public_path__ + "static/img/YB-25H.9e141721.png";